<script setup lang="ts">
import ErrorBoundary from './providers/ErrorBoundary.vue'
import ToastRegion from './providers/ToastRegion.vue'
import { useAppShell } from './composables/useAppShell'

useAppShell()
</script>

<template>
  <ErrorBoundary>
    <RouterView />
  </ErrorBoundary>
  <ToastRegion />
</template>
